import React from 'react';
import MuiChip, { type ChipProps as MuiChipProps } from '@mui/material/Chip';

import {
  statusError,
  statusSuccess,
  statusTextError,
  statusTextSuccess,
  statusTextWarning,
  statusWarning,
} from 'utils/color-styles';

export type ChipProps = Omit<MuiChipProps, 'onDelete'> & {
  reverse?: boolean;
};

const colors = {
  success: {
    color: statusTextSuccess,
    backgroundColor: statusSuccess,
  },
  warning: {
    color: statusTextWarning,
    backgroundColor: statusWarning,
  },
  error: {
    color: statusTextError,
    backgroundColor: statusError,
  },
};

export const Chip = ({ style, reverse = false, ...rest }: ChipProps): JSX.Element => {
  const customColors = colors[rest.color as keyof typeof colors];
  return (
    <MuiChip
      {...rest}
      style={{
        ...(reverse && { direction: 'rtl', paddingRight: '24px' }),
        ...customColors,
        ...style,
      }}
    />
  );
};
